import {
  GET_TEMPLATES,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_BY_ID,
  GET_TEMPLATES_BY_ID_SUCCESS,
  GET_TEMPLATES_BY_TYPE,
  GET_TEMPLATES_BY_TYPE_SUCCESS,
  GET_TEMPLATES_BY_ID_CONTROL,
  GET_TEMPLATES_BY_ID_CONTROL_SUCCESS,
  GET_TEMPLATES_STUDIO_BY_TYPE,
  GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS,
  POST_PUBLISH_TEMPLATES,
  POST_DRAFT_TEMPLATES,
  PATCH_PUBLISHED_TEMPLATE,
  PATCH_TEMPLATES_BY_ID,
  PATCH_LABEL_QUESTION_BY_ID,
  DELETE_TEMPLATES_BY_ID,
  DELETE_TEMPLATES_GOVERNANCE_BY_ID,
  SET_LOADER_DATA,
  DUPLICATE_TEMPLATES,
  DUPLICATE_TEMPLATES_GOVERNANCE,
} from "./constants"
// GET
export function getTemplatesAction() {
  return {
    type: GET_TEMPLATES,
  }
}

export function getTemplatesSuccess(payload) {
  return {
    type: GET_TEMPLATES_SUCCESS,
    payload: payload,
  }
}

export function getTemplatesByIdAction(payload) {
  return {
    type: GET_TEMPLATES_BY_ID,
    payload: payload,
  }
}

export function getTemplatesByIdSuccess(payload) {
  return {
    type: GET_TEMPLATES_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function getTemplatesByControlIdAction(payload) {
  return {
    type: GET_TEMPLATES_BY_ID_CONTROL,
    payload: payload,
  }
}

export function getTemplatesByControlIdSuccess(payload) {
  return {
    type: GET_TEMPLATES_BY_ID_CONTROL_SUCCESS,
    payload: payload,
  }
}

export function getTemplateByTypeAction(payload) {
  return {
    type: GET_TEMPLATES_BY_TYPE,
    payload: payload,
  }
}

export function getTemplateByTypeSuccess(payload) {
  return {
    type: GET_TEMPLATES_BY_TYPE_SUCCESS,
    payload: payload,
  }
}
// get templates studio non gouvernance
export function getTemplateStudioByTypeAction(payload) {
  return {
    type: GET_TEMPLATES_STUDIO_BY_TYPE,
    payload: payload,
  }
}

export function getTemplateStudioByTypeSuccess(payload) {
  return {
    type: GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS,
    payload: payload,
  }
}
// POST
export function postPublishTemplateAction(payload) {
  return {
    type: POST_PUBLISH_TEMPLATES,
    payload: payload,
  }
}

export function postDraftTemplateAction(payload) {
  return {
    type: POST_DRAFT_TEMPLATES,
    payload: payload,
  }
}

export function patchPublishedTemplateAction(payload) {
  return {
    type: PATCH_PUBLISHED_TEMPLATE,
    payload: payload,
  }
}

// PATCH
export function patchTemplateByIdAction(payload) {
  return {
    type: PATCH_TEMPLATES_BY_ID,
    payload: payload,
  }
}

export function patchLabelQuestionByIdAction(payload) {
  return {
    type: PATCH_LABEL_QUESTION_BY_ID,
    payload: payload,
  }
}

// DELETE
export function deleteTemplateByIdAction(payload) {
  return {
    type: DELETE_TEMPLATES_BY_ID,
    payload: payload,
  }
}

export function deleteTemplateGovernanceByIdAction(payload) {
  return {
    type: DELETE_TEMPLATES_GOVERNANCE_BY_ID,
    payload: payload,
  }
}

// DUPLICATE
export function duplicateTemplateFormAction(payload) {
  return {
    type: DUPLICATE_TEMPLATES,
    payload: payload,
  }
}

export function duplicateTemplateGouvernanceAction(payload) {
  return {
    type: DUPLICATE_TEMPLATES_GOVERNANCE,
    payload: payload,
  }
}

// LOADER
export function setLoaderDataAction(payload) {
  return {
    type: SET_LOADER_DATA,
    payload: payload,
  }
}
